<template>
  <div>
    <CCard>
      <CCardHeader>
        <CRow>
          <CCol class="align-self-center">
            <label class="mb-0 font-lg font-weight-bold">Courses</label>
          </CCol>
          <CCol class="text-right">

            <CButton @click="changeState" class="text-white mr-2" color="success" v-if="defaultState">
              <CIcon height="36" name="cil-library-add"/>
            </CButton>

            <CButton @click="changeState" class="text-white mr-2" color="danger" v-if="!defaultState">
              <CIcon height="36" name="cil-x"/>
            </CButton>
          </CCol>
        </CRow>
      </CCardHeader>
      <CCardBody class="pt-0">
        <CCollapse :show="defaultState">
          <courses
              :courses="courses"
              :fields="fields"
              @deleteCourse="confirmDeleteCourse"
              @editCourse="editCourse"/>
        </CCollapse>
        <add-course
            :form="form"
            @cancel="changeState"
            @confirm="confirmAddCourse"
            class="mt-3"
            v-if="!defaultState"
        />
      </CCardBody>
    </CCard>
    <CModal
        :centered="true"
        :show.sync="confirmModal"
        color="info"
        title="Confirm"
    >
      Code: {{ form.courseCode }}<br/>
      Course name: {{ form.name }}<br/>
      Year: {{ form.year }}
      <template #footer-wrapper>
        <CRow class="p-3">
          <CCol class="text-right">
            <CButton @click="confirmModal = false" class="mr-2" color="danger">Cancel</CButton>
            <CButton @click="addCourse" color="success">Confirm</CButton>
          </CCol>
        </CRow>
      </template>
    </CModal>
  </div>
</template>

<script>
import Courses from "@/components/course/courses";
import AddCourse from "@/components/course/addCourse";
import {mapGetters} from "vuex"

export default {
  name: "MainCourse",
  components: {AddCourse, Courses},
  created() {
    this.$store.dispatch("course/onSetCourses")
  },
  mounted() {
    this.$store.dispatch("course/onSetCourses")
  },
  computed: {
    ...mapGetters({
      courses: "course/getCourses",
      course: "course/getCourse",
      actionStatus: "action/actionStatus"
    })
  },
  watch: {
    defaultState(value) {
      if (value === true) {
        this.setEmptyForm()
      }
    },
    actionStatus(value) {
      if (value) {
        this.deleteCourse()
      }
    },
    courses(value) {
      this.defaultState = true
    },
    course(value) {
      this.form = value
      this.defaultState = !this.defaultState
    }
  },
  data() {
    return {
      defaultState: true,
      confirmModal: false,
      form: {
        courseCode: "",
        name: "",
        year: 0
      },
      tempId: "",
      users: [
        {username: 'Samppa Nori', registered: '2012/01/01', role: 'Member', status: 'Active'},
        {username: 'Estavan Lykos', registered: '2012/02/01', role: 'Staff', status: 'Banned'},
        {username: 'Chetan Mohamed', registered: '2012/02/01', role: 'Admin', status: 'Inactive'},
        {username: 'Derick Maximinus', registered: '2012/03/01', role: 'Member', status: 'Pending'},
        {username: 'Friderik Dávid', registered: '2012/01/21', role: 'Staff', status: 'Active'},
        {username: 'Yiorgos Avraamu', registered: '2012/01/01', role: 'Member', status: 'Active'},
        {username: 'Quintin Ed', registered: '2012/02/01', role: 'Admin', status: 'Inactive'},
        {username: 'Enéas Kwadwo', registered: '2012/03/01', role: 'Member', status: 'Pending'},
      ],
      fields: [
        {key: "no", label: "No.", _style: "width: 10%"},
        {key: "courseCode", label: "Course code"},
        {key: "name", label: "Course name"},
        {key: "year", label: "Year"},
        {key: "editOptions", label: "#", _style: "width: 18%"}
      ]
    }
  },
  methods: {
    setEmptyForm() {
      this.form.courseCode = ""
      this.form.name = ""
      this.form.year = 0
    },
    confirmAddCourse(value) {
      this.confirmModal = true
      this.form = value
    },
    changeState() {
      this.defaultState = !this.defaultState
      if (this.defaultState === true) {
        delete this.form._id
        delete this.form.__v
      }
    },
    addCourse() {
      this.confirmModal = false
      if (this.form._id) {
        this.$store.dispatch("course/onEditCourse", this.form)
      } else {
        this.$store.dispatch("course/onAddCourse", this.form)
      }
    },
    editCourse(id) {
      this.$store.dispatch("course/onFetchSingleCourse", id)
    },
    confirmDeleteCourse(id) {
      this.tempId = id
      let body = {
        title: "Notification",
        color: "warning",
        status: true,
        text: "Do you really want to delete the course?"
      }
      this.$store.commit("modal/onSetConfirmActionModalStatus", body)
    },
    deleteCourse() {
      this.$store.dispatch("course/onDeleteCourse", this.tempId)
    }
  }
}
</script>
